import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { CartService } from './../cart/cart.service';
import { CaseIdentifier } from './../shared/case-identifier';
import { CaseViewService } from './../case-view/case-view.service';
import { EventService } from './../shared/event.service';
import { AuthenticationService } from '../shared/authentication.service';
import { CiprsRole, UserProfile } from '../shared/user';
import { PublicAccessTerminalService } from '../shared/public-access-terminal.service';
import { RoutingHistoryService } from '../shared/routing-history.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less']
})
export class HeaderComponent {

  private routeUrl: string = this.router.url;
  cartSize: number;
  currentUser: UserProfile = this.authenticationService.getCurrentUser();

  constructor(private authenticationService: AuthenticationService,
              private cartService: CartService,
              private caseViewService: CaseViewService,
              private eventService: EventService,
              private publicAccessTerminalService: PublicAccessTerminalService,
              private router: Router,
              private routingHistoryService: RoutingHistoryService) {
    this.router.events.subscribe(theRoute => {
      if (theRoute instanceof NavigationEnd) {
        this.routeUrl = theRoute.urlAfterRedirects;
      }
    });
    cartService.cartSizeChanged$.subscribe(size => { this.cartSize = size; });
    authenticationService.authenticatedUserChange$.subscribe(user => { this.currentUser = user; })
   }

  openCart(): void {
    this.router.navigate([{ outlets: { view: 'cart' }}]);
  }

  openHelp(): void {
    this.eventService.openHelp();
  }

  openAbout(): void {
    this.eventService.openAbout();
  }

  openClearHistory(): void {
    this.eventService.openClearHistory();
  }

  onBackClicked() {
   // const viewingFromCart = this.routeUrl.indexOf('fromCart') !== -1;
   // this.router.navigate([{ outlets: { view: viewingFromCart ? 'cart' : null }}]);

    // using RoutingHistoryService
    // console.log('current url=' + this.routeUrl);
    this.router.navigateByUrl(this.routingHistoryService.popPreviousUrl());
  }

  isViewOutletActivated(): boolean {
    return this.routeUrl &&
           this.routeUrl.indexOf('view:') !== -1;
  }
  isDetailsViewOutletActivated(): boolean {
    return this.routeUrl &&
           this.routeUrl.indexOf('view:details/') !== -1;
  }
  private isLandingPage(): boolean {
    return this.routeUrl &&
           this.routeUrl === '/';
  }
  private isJuvenile(): boolean {
    return this.routeUrl &&
           this.routeUrl.indexOf('/juvenile') !== -1;
  }
  private isCivil(): boolean {
    return this.routeUrl &&
           this.routeUrl.indexOf('/civil') !== -1;
  }
  private isBondsman(): boolean {
    return this.routeUrl &&
           this.routeUrl.indexOf('/bondsman') !== -1;
  }
  onEmailClicked(): void {
    this.caseViewService.onEmailClicked();
  }
  onPrintClicked(): void {
    this.caseViewService.onPrintClicked();
  }

  isCaseInCart(): boolean {
    return this.caseViewService.isCaseInCart();
  }
  addCaseToCart(): void {
    this.caseViewService.addCaseToCart();
  }
  removeCaseFromCart(): void {
    this.caseViewService.removeCaseFromCart();
  }

  showHomeLink(): boolean {
    return !this.isViewOutletActivated() &&
           (this.isCivil() ||
           this.isJuvenile() ||
           this.isBondsman());
  }

  showCartReleatedDetailsOptions(): boolean {
    return !(this.isJuvenile() || this.isBondsman());
  }

  showCartLink(): boolean {
    return this.isCivil();
  }

  showClearHistory(): boolean {
    return this.isCivil();
  }

  showHelpLink(): boolean {
    return this.isDetailsViewOutletActivated() &&
           this.isCivil();
  }

  showLoggedInUser(): boolean {
    return !this.publicAccessTerminalService.isPublicAccessTerminal();
  }

  logout(): void {
    if (this.cartService.isEmpty()) {
      this.performLogout();
    } else {
      this.cartService.canCartBeAbandoned().then((value) => {
        if (value) {
          this.performLogout();
        }
      });
    }
  }

  private performLogout(): void {
    this.authenticationService.logOut();
    this.router.navigateByUrl('/logout;reason=logout');
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/header/header.component.ts